export const PARKING_FILTER_GROUPS = ['covered', 'evCharging', 'secured', 'size'];
export const PARKING_ADDRESS_TO_ENTRANCE_MAX_DISTANCE_METERS = 300;
export const PARKING_PROPERTIES_FILTERS = [
    'carport',
    'disabled',
    'evChargingAc',
    'evChargingDcUnder100kW',
    'evChargingDc100To200kW',
    'evChargingDc200To300kW',
    'evChargingDc300To400kW',
    'evChargingDcOver400kW',
    'guarded',
    'indoor',
    'lockable',
    'lpgFriendly',
    'nonCompact',
    'open24h',
    'outdoor',
    'xxl',
    'truckUnder7t',
    'truck7To12t',
    'truckOver12t',
    'truckSemi',
];
export const PARKING_PROPERTIES = [
    'evChargingAc',
    'evChargingDcUnder100kW',
    'evChargingDc100To200kW',
    'evChargingDc200To300kW',
    'evChargingDc300To400kW',
    'evChargingDcOver400kW',
    'disabled',
    'guarded',
    'lockable',
    'carport',
    'indoor',
    'outdoor',
    'open24h',
    'lpgForbidden',
    'lpgFriendly',
    'compact',
    'truckUnder7t',
    'truck7To12t',
    'truckOver12t',
    'truckSemi',
    'xxl',
];
export const PARKING_PROPERTIES_WITH_CUSTOM_DIMENSIONS = [
    'compact',
    'xxl',
    'truckUnder7t',
    'truck7To12t',
    'truckOver12t',
    'truckSemi',
];
export const PARKING_PROPERTIES_SECURITY = ['guarded', 'lockable'];
export const PARKING_PROPERTIES_WITH_LOCK_CODE = ['lockable'];
export const PARKING_PROPERTIES_EV_CHARGING = [
    'evChargingAc',
    'evChargingDcUnder100kW',
    'evChargingDc100To200kW',
    'evChargingDc200To300kW',
    'evChargingDc300To400kW',
    'evChargingDcOver400kW',
];
export const PARKING_PROPERTY_CONFLICTS = {
    evChargingAc: [
        'evChargingDcUnder100kW',
        'evChargingDc100To200kW',
        'evChargingDc200To300kW',
        'evChargingDc300To400kW',
        'evChargingDcOver400kW',
    ],
    evChargingDcUnder100kW: [
        'evChargingAc',
        'evChargingDc100To200kW',
        'evChargingDc200To300kW',
        'evChargingDc300To400kW',
        'evChargingDcOver400kW',
    ],
    evChargingDc100To200kW: [
        'evChargingDcUnder100kW',
        'evChargingAc',
        'evChargingDc200To300kW',
        'evChargingDc300To400kW',
        'evChargingDcOver400kW',
    ],
    evChargingDc200To300kW: [
        'evChargingDcUnder100kW',
        'evChargingDc100To200kW',
        'evChargingAc',
        'evChargingDc300To400kW',
        'evChargingDcOver400kW',
    ],
    evChargingDc300To400kW: [
        'evChargingDcUnder100kW',
        'evChargingDc100To200kW',
        'evChargingDc200To300kW',
        'evChargingAc',
        'evChargingDcOver400kW',
    ],
    evChargingDcOver400kW: [
        'evChargingDcUnder100kW',
        'evChargingDc100To200kW',
        'evChargingDc200To300kW',
        'evChargingDc300To400kW',
        'evChargingAc',
    ],
    lpgForbidden: ['lpgFriendly'],
    lpgFriendly: ['lpgForbidden'],
    carport: ['outdoor'],
    indoor: ['outdoor'],
    outdoor: ['carport', 'indoor'],
    compact: ['xxl', 'truckUnder7t', 'truck7To12t', 'truckOver12t', 'truckSemi'],
    xxl: ['compact'],
    truckUnder7t: ['truck7To12t', 'truckOver12t', 'truckSemi', 'compact'],
    truck7To12t: ['truckUnder7t', 'truckOver12t', 'truckSemi', 'compact'],
    truckOver12t: ['truckUnder7t', 'truck7To12t', 'truckSemi', 'compact'],
    truckSemi: ['compact', 'truckUnder7t', 'truck7To12t', 'truckOver12t'],
};
